import React, { useContext, useEffect } from "react";
import "../styles/ThankYouPage.scss";
import { GlobalContext } from "../App";
function ThankYouPage() {
  const {
    isLoading,
    setIsLoading,
    currentFormStep,
    setCurrentFormStep,
    phase,
    setPhase,
  } = useContext(GlobalContext);

  return (
    <div className="thank-you-page-container">
      <div className="thank-you-title"></div>
      <br></br>
      {phase == 1 && (
        <div className="thank-you-text" id="div_thankyou">
          感謝您的參與！
          第一階段創意問題勝出者將於9月29日獲專人及電郵通知，敬請密切留意。
          <br></br>
          Thank you for your participation! The competition winners of Phase 1
          will be notified via representative and email on 29 September. Please
          stay tuned and keep an eye on your inbox.
        </div>
      )}
      {phase == 2 && (
        <div className="thank-you-text" id="div_thankyou">
          感謝您的參與！
          第二階段創意問題勝出者將於10月20日獲專人及電郵通知，敬請密切留意。
          <br></br>
          Thank you for your participation! The competition winners of Phase 2
          will be notified via representative and email on 20 October. Please
          stay tuned.
        </div>
      )}
      <br></br>
      <a href="/252hmusicconcert/" className="submit-button">
        更多登記 | Register more
      </a>
    </div>
  );
}

export default ThankYouPage;
